import React, { useRef, useState } from "react";
import { useDropzone } from "react-dropzone";
import Header from "../elements/Header/Header";
import InputTextSlide from "../components/InputTextSlide/InputTextSlide";

import Loading from "../elements/LoadingScreen/Loading";
//import './Slideshow.css'
import Button from "../components/Button/Button";


import { API_URL } from "../constans/roles";
import { footer1,footer2 } from "./footers";
import LabelSelect from "../components/LabelSelect/LabelSelect";



function createPhoneNum(txt) {
  return txt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
}

const FooterGenerator = () => {

  const defauultForma = {
    files:null,
    name: "",
    phone: "",
    skype: "",
    mail: "",
    job: ""
  }

  const [choosenFooter,setChoosenFooter] = useState(2)
  const [formData, setFormData] = useState(defauultForma);
  const [file, setFile] = useState(null);
  const [fPrevew,setFPreview] = useState({})
  const [message,setMessage] = useState("");
  const [imageMess,setImMess] = useState("")
  const [loading,setLoading] = useState(false)

  const iFrame = useRef(null);


  const onDrop = (acceptedFile) => {
    setFile(acceptedFile[0]);

    setFPreview(URL.createObjectURL(acceptedFile[0]))

    setImMess("Czeka na załadowanie na serwer")
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    multiple: false,
    accept: {
      "image/png": [".png"],
      "image/jpeg": [".jpg", ".jpeg"],
      "image/avif": [".avif"],
      "video/webm": [".webm"],
    },
  });

  const handleChange = (e) => {
    console.log(choosenFooter)
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCopy = async () => {
    console.log(navigator.clipboard)

    const clipboardItem = new ClipboardItem({
      "text/plain": new Blob(
        [iFrame.current.srcdoc],
        { type: "text/plain" }
      ),
      "text/html": new Blob(
        [iFrame.current.srcdoc],
        { type: "text/html" }
      ),
    });
    
    navigator.clipboard.write([clipboardItem]);
    //navigator.clipboard.write(iFrame.current.srcdoc)
  }
  const handleSubmit = async () => {
    const data = new FormData();
    data.append("file", file);
    console.log(file)

    setLoading(true)
    try {
        const response = await fetch(API_URL+ '/' + "api/footerGenerator/upload", {
          method: "POST",
          body: data,
        });
  
        if (!response.ok) {
          throw new Error("Upload failed!");
        }
      
  
        const result = await response.json();
       
        setMessage(result.remoteFolderPath)

        setImMess("Zdjęcie poprawnie dodane na serwer!")
      } catch (error) {
        setImMess("Coś poszło nie tak... Nie udało się dodać zdjęcia")
        alert("Błąd podczas wysyłania danych: " + error.message);
      }

      setLoading(false)
  };

  function handleChangeFooter(e) {
    setChoosenFooter(e.target.value)
  }

  return (
    <>
    <Header />
    { loading && <Loading info={"Proszę czekać, zdjęcie jest wgrywane..."}/> }
    <div className="slideshow">
    <form className="slideshow__form-wrapper">
      
   


    

      <div className="slideshow-flex-row" style={{padding:'20px 0'}}>
      <InputTextSlide 
            placeholder="Imie i nazwisko"
            value={formData.name}
            text="Imie i nazwisko: "
            name="name"
            handleChange={(e) => handleChange(e)}
        />

      <InputTextSlide  
            placeholder="Stanowisko"
            value={formData.job}
            text="Stanowisko: "
            name="job"
            handleChange={(e) => handleChange(e)}
        />
      </div>
 
      <div className="slideshow-flex-row" style={{padding:'20px 0'}}>
      <InputTextSlide  
            placeholder="Numer telefonu"
            value={formData.phone}
            max={9}
            onlyNum={true}
            text="Numer telefonu: "
            name="phone"
            handleChange={(e) => handleChange(e)}
        />

      <InputTextSlide  
            placeholder="Pełny mail"
            value={formData.mail}
            text="Pełny mail: "
            name="mail"
            handleChange={(e) => handleChange(e)}
        />
   </div>

   <div className="slideshow-flex-row" style={{padding:'20px 0', justifyContent:'center'}}>
   <div {...getRootProps()} style={{ 
          border: "0px dashed black", 
          padding: "30px", 
          marginBottom: "10px", 
          marginTop: "10px", 
          width:'100%', 
          minHeight:'180px',
          maxWidth:'200px', 
          fontSize:'9px',
          textAlign: 'center',
          backgroundColor:'white', 
          color:'var(--sec-font)'
          }}>
        <input {...getInputProps()} />
        <p>Przeciągnij i upuść zdjęcie lub kliknij i wybierz</p>
        {
          file &&
          <img
                src={fPrevew}
                alt={file.name}
                style={{ width: "50px", height: "50px", objectFit: "cover" }}
              />
        }
   
      </div>

      <div style={{display:'flex',flexDirection:'column'}}>
        <Button 
            txt="Wyślij zdjęcie"
            click={handleSubmit}
            styles={{
              cursor: "pointer",
              margin: '20px 20px'
            }}
        />
             <Button 
            txt="Skopiuj stopke"
            click={handleCopy}
            styles={{
              backgroundColor: "black",
              cursor: "pointer",
              margin: '20px 20px'
            }}
        />
      </div>
   </div>
{
  /**
        <InputTextSlide  
            placeholder="Pełny skype"
            value={formData.skype}
            text="Pełny skype: "
            name="skype"
            handleChange={(e) => handleChange(e)}
        />
  
   */
}


      
      <div>

        <LabelSelect 
                options={
                    [
                        {value:2,txt:"Nowa"},
                        {value:1,txt:"Stara"}
                        
                    ]
                }
                placeholder={false}
                text="Wybierz stopke: "
                name="footer"
                handleChange={handleChangeFooter}
        />
        
      </div>
      <h3>{imageMess}</h3>

    { console.log(choosenFooter === 1 )}
      <iframe width="700"  style={{overflow:"hidden", backgroundColor:'white'}} ref={iFrame} height={250} srcDoc={
        choosenFooter == 1 ? footer1(formData, message, createPhoneNum) : footer2(formData, message, createPhoneNum)
      }>

      </iframe>
    </form>
    </div>
    </>
  );
};

export default FooterGenerator;
